import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationsService } from './organizations.service';
import * as OrganizationsActions from './organizations.actions';

@Injectable()
export class OrganizationsEffects {
    loadOrganizations$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OrganizationsActions.fetchOrganizations),
            mergeMap(() =>
                this.organizationsService.fetchOrganizations().pipe(
                    map((organizations) => OrganizationsActions.fetchOrganizationsSuccess({ organizations })),
                    catchError((error) => of(OrganizationsActions.fetchOrganizationsFailed({ error })))
                )
            )
        );
    });

    loadOrganizationsByIds$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(OrganizationsActions.fetchOrganizationsByIds),
            mergeMap(({ organizationIds }) => {
                return this.organizationsService.fetchOrganizationsByIds(organizationIds).pipe(
                    map((organizations) => {
                        return OrganizationsActions.fetchOrganizationsByIdsSuccess({ organizations });
                    }),
                    catchError((error) => {
                        console.error('OrganizationsEffects: Error fetching organizations', error);
                        return of(OrganizationsActions.fetchOrganizationsByIdsFailed({ error }));
                    })
                );
            })
        );
    });

    constructor(
        private actions$: Actions,
        private organizationsService: OrganizationsService
    ) {}
}
